import { APPLOADER_START, APPLOADER_END } from "../actions/actionAppLoader";
const initialState = {
    loading: false
};

function reducerAppLoader(state = initialState, action) {
    switch (action.type) {
        case APPLOADER_START: {
            return {
                ...state,
                loading: true
            };
        }
        case APPLOADER_END: {
            return {
                ...state,
                loading: false
            };
        }
        default: {
            return state;
        }
    }
}

export default reducerAppLoader;
